import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=6b66c559&scoped=true&"
import script from "./Pause.vue?vue&type=script&lang=js&"
export * from "./Pause.vue?vue&type=script&lang=js&"
import style0 from "./Pause.vue?vue&type=style&index=0&id=6b66c559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66c559",
  null
  
)

export default component.exports